import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../Shared/Buttons/Button";
import { useNavigate } from "react-router-dom";

function SelectMenuPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div>
      <div className="page-container page-container--narrow">
        <div className={classes.linkContainer}>
           <div className={classes.boxStyle}>
            <p className={classes.menuItem}>Create a new project linked to a specific registration point.</p>
            <Button
              onClick={() => {
                navigate("/create", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Create a project
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>View all your projects. (See results, reports,...)</p>
            <Button
              onClick={() => {
                navigate("/projectreportoverview", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Project Overview
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>View all your graphs</p>
            <Button
              onClick={() => {
                navigate("/graphs", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Graph Overview
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>View and manage all your measurements</p>
            <Button
              onClick={() => {
                navigate("/datamanagement", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Data management
            </Button>
          </div>
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>View and manage all financial data</p>
            <Button
              onClick={() => {
                navigate("/financialcenter", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Financial Center
            </Button>
          </div>
          {/* <div className={classes.boxStyle}>
              <p className={classes.menuItem}>View an overview of all revenue and costs linked to your accounts</p>
              <Button className={classes.linkButton} variant="contained" onClick={() => { navigate('/generalledgeraccount', { state: { from: '/' } }) }}>General ledger account</Button>
          </div> */}
          <div className={classes.boxStyle}>
            <p className={classes.menuItem}>Configuration</p>
            <Button
              onClick={() => {
                navigate("/configuration", { state: { from: "/" } });
              }}
              className={classes.linkButton}
            >
              Configuration
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectMenuPage;

const useStyles = makeStyles((theme) => ({
  linkContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "160px",
  },
  boxStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFFF",
    border: "1px solid var(--color-border-light)",
    borderRadius: "8px",

    padding: "16px",
    paddingLeft: "24px",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  menuItem: {
    color: "#1D3557",
    margin: "0",

    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      width: "100% !important",
      marginBottom: "15px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100% !important",
      fontSize: "1.2rem",
    },
  },
  linkButton: {
    minWidth: "200px",
  },
}));